"use strict";
(() => {
    var M = "ADD_TO_CART_ERROR",
        I = "ADD_TO_CART",
        _ = "CUSTOMER_INFO",
        A = "REQUEST_CUSTOMER_INFO",
        T = "NAVIGATE_TO_LOGIN";
    var w = {
            pillowP1: "24x75",
            pillowP2: "48x75",
            pillowP3: "50x50",
            pillowP4: "70x70",
            pillowP5: "100x100",
            pillowP6: "35x35",
            pillowP7: "72x48",
            pillowP8: "96x48",
        },
        R = (n) => n.charAt(0).toUpperCase() + n.slice(1),
        b = {
            en: "Cushion Details",
            de: "Kissen Details",
            fr: "D\xE9tails coussins",
            it: "Dettagli cuscini",
            nl: "Kussen details",
        };
    var k = ({ groupId: n, items: a, lang: i }) => {
        let l = [...a].sort(
                (r, e) => (r.bundlePosition ?? Number.MAX_SAFE_INTEGER) - (e.bundlePosition ?? Number.MAX_SAFE_INTEGER)
            ),
            c = { _set_id: n },
            p = new Map();
        for (let r of l) {
            let e = R(r.color ?? "unknown"),
                t = R(r.fabric ?? "unknown"),
                o = w[r.elementType ?? ""] ?? r.elementType ?? "unknown",
                s = `${e}-${t}`;
            p.has(s) || p.set(s, new Map());
            let u = p.get(s);
            u.set(o, (u.get(o) ?? 0) + 1);
        }
        let g = [];
        for (let [r, e] of Array.from(p.entries())) {
            let t = Array.from(e.entries())
                .map(([o, s]) => `${s}x ${o}cm`)
                .join(" / ");
            g.push(`${r} / ${t}`);
        }
        let d = g.join(" | ");
        if (d) {
            let r = b[i ?? "en"] ?? b.en;
            c[r] = d;
        }
        c._cushion_data = JSON.stringify(
            l.map((r) => ({
                size: w[r.elementType ?? ""] ?? r.elementType ?? "unknown",
                color: r.color ?? "unknown",
                fabric: r.fabric ?? "unknown",
            }))
        );
        let m = l.find((r) => r.color)?.color ?? "";
        return m && (c._color = m), c;
    };
    var h = (n) => n.split("/").pop(),
        f = {
            default: {
                Harvey: "43192163008665",
                Donna: "42941836198041",
                Donna2: "56257775272318",
                Katrina: "42941837344921",
                Katrina2: "56220850782590",
                MikeL: "42941825679513",
                MikeR: "42941825679513",
                MikeL2: "56262952386942",
                MikeR2: "56262952386942",
                Mike: "56262952386942",
                Nina: "43454665261209",
                Louis: "43466405380249",
                Amelie: "42941835378841",
                Jessica: "42941837115545",
                Paula: "43475298451609",
                Marie: "42941839016089",
                Amy: "56258480865662",
                Aera: "56474279051646",
                Terra: "56987195605374",
            },
            ch: {
                Harvey: "43192163008665",
                Donna: "42941836198041",
                Donna2: "56257775272318",
                Katrina: "42941837344921",
                Katrina2: "56220850782590",
                MikeL: "42941825679513",
                MikeR: "42941825679513",
                MikeL2: "56262952386942",
                MikeR2: "56262952386942",
                Mike: "56262952386942",
                Nina: "43454665261209",
                Louis: "43466405380249",
                Amelie: "42941835378841",
                Jessica: "42941837115545",
                Paula: "43475298451609",
                Marie: "42941839016089",
                Amy: "56258480865662",
                Aera: "56474279051646",
                Terra: "56987195605374",
            },
            eu: {
                Harvey: "42753242661054",
                Donna: "42481184768190",
                Donna2: "55752728150396",
                Katrina: "42481195745470",
                Katrina2: "55720086176124",
                MikeL: "42481218879678",
                MikeR: "42481218879678",
                MikeL2: "55759630991740",
                MikeR2: "55759630991740",
                Mike: "55759630991740",
                Nina: "43092670546110",
                Louis: "43326118854846",
                Amelie: "42481180410046",
                Jessica: "42481180410046",
                Paula: "43099401322686",
                Marie: "42481212653758",
                Amy: "55756018712956",
                Aera: "55893192376700",
                Terra: "56527504834940",
                Luma: "56791922671996",
            },
            it: {
                Harvey: "44647556808892",
                Donna: "44647504871612",
                Donna2: "45210168459452",
                Katrina: "44647505133756",
                Katrina2: "45179500298428",
                MikeL: "44647505199292",
                MikeR: "44647505199292",
                MikeL2: "45213508632764",
                MikeR2: "45213508632764",
                Mike: "45213508632764",
                Nina: "44647579975868",
                Louis: "44647599112380",
                Amelie: "44647504904380",
                Jessica: "44647504969916",
                Paula: "44647580041404",
                Marie: "44647505100988",
                Amy: "45210681475260",
                Aera: "45356768723132",
                Terra: "45976858460348",
            },
            at: {
                Harvey: "55268618174843",
                Donna: "55268556407163",
                Donna2: "55746211119483",
                Katrina: "55268556800379",
                Katrina2: "55730125177211",
                MikeL: "55268557226363",
                MikeR: "55268557226363",
                MikeL2: "55748334387579",
                MikeR2: "55748334387579",
                Mike: "55748334387579",
                Nina: "55268651499899",
                Louis: "55268675387771",
                Amelie: "55268556439931",
                Jessica: "55268556669307",
                Paula: "55268655595899",
                Marie: "55268556964219",
                Amy: "55746617213307",
                Aera: "55870007083387",
                Terra: "56106873913723",
                Luma: "56258537685371",
            },
            fr: {
                Harvey: "52232076263793",
                Donna: "52232031109489",
                Donna2: "62366281728369",
                Katrina: "52232031207793",
                Katrina2: "55789231210865",
                MikeL: "52232031371633",
                MikeR: "52232031371633",
                MikeL2: "62368756302193",
                MikeR2: "62368756302193",
                Nina: "52232097825137",
                Louis: "52232118763889",
                Amelie: "52232030945649",
                Jessica: "52232031175025",
                Paula: "52232103231857",
                Marie: "52232031273329",
                Amy: "62366559666545",
                Aera: "62550367928689",
                Terra: "63239555973489",
            },
            nl: {
                Harvey: "44712062976053",
                Donna: "44712065859637",
                Donna2: "44712065859637",
                Nina: "44751457583157",
                Aera: "44763827404853",
                Terra: "45015198924853",
                Luma: "45235286966325",
            },
        },
        L = (n) => (n in f ? n : "default"),
        P = (n, a) => {
            let i = crypto.randomUUID(),
                l = ["en", "de", "fr", "it", "nl"],
                c = window.location.pathname.split("/")[1] ?? "",
                p = l.includes(c) ? c : "de";
            if (n.preview && i)
                try {
                    localStorage.setItem(i, n.preview);
                } catch (e) {
                    console.warn("Failed to store preview in localStorage:", e);
                }
            let g = n.items.reduce((e, t) => {
                    if (t.bundleId && t.bundlePosition) {
                        let o = e[t.bundleId] || { bundleId: t.bundleId, items: [] };
                        o.items.push(t), (e[t.bundleId] = o);
                    }
                    return e;
                }, {}),
                d = [];
            Object.entries(g).forEach(([e, t]) => {
                let { bundleId: o, items: s } = t,
                    u = k({ groupId: i, items: s, lang: p }),
                    y = h(o);
                if (!y) {
                    console.error("\u274C [ATC] Could not extract variant ID from bundleId:", o);
                    return;
                }
                d.push({ quantity: 1, id: y, properties: u });
            }),
                n.items.forEach((e) => {
                    if (e.bundleId && e.bundlePosition) {
                        console.log("Skipping bundle item:", e.shopifyId, "bundleId:", e.bundleId);
                        return;
                    }
                    let t = { _set_id: i };
                    e.omitColor || (t.Color = e.color || n.color);
                    let o = h(e.shopifyId);
                    o &&
                        (console.log("Adding individual item:", o),
                        d.push({ quantity: e.quantity, id: o, properties: t }));
                });
            let m = L(n.store),
                r = f[m]?.[n.model] || f.default[n.model];
            r &&
                d.push({
                    quantity: 1,
                    id: r,
                    properties: { _link: n.compositionUrl || "", _set_id: i, _title: n.model, _price: "0", _set: i },
                }),
                console.log(
                    "\u{1F6D2} [ATC] Attempting to add items:",
                    d.map((e) => ({ id: e.id, quantity: e.quantity, properties: e.properties }))
                ),
                fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ items: d }),
                })
                    .then(async (e) => {
                        if (!e.ok) {
                            let t = await e.json().catch(() => ({})),
                                o = t?.description || e.statusText || "Unknown error";
                            throw (
                                (console.error("\u274C [ATC] Cart add failed:", o),
                                console.error("\u274C [ATC] Error details:", t),
                                d.forEach((s, u) => console.error(`  ${u + 1}. Variant ID: ${s.id}`, s.properties)),
                                a.postMessage(
                                    {
                                        type: M,
                                        payload: {
                                            error: o,
                                            failedItems: d.map(({ id: s, quantity: u }) => ({ id: s, quantity: u })),
                                        },
                                    },
                                    "*"
                                ),
                                new Error(o))
                            );
                        }
                        return e.json();
                    })
                    .then(() => {
                        let e = window.location.pathname.split("/")[1] ?? "",
                            o = ["en", "de", "fr", "it"].includes(e) ? `/${e}` : "";
                        window.location.href = `${o}/cart`;
                    })
                    .catch(console.error);
        },
        E = (n) => {
            if (n?.data?.type)
                try {
                    let a = n.data;
                    if (a.type === I) P(a.payload, n.source);
                    else if (a.type === A) {
                        let i = window.__livomCustomer ?? {
                            isLoggedIn: !1,
                            email: "",
                            firstName: "",
                            loginUrl: "/account/login",
                        };
                        n.source.postMessage({ type: _, payload: i }, "*");
                    } else if (a.type === T) {
                        let i = window.__livomCustomer?.loginUrl ?? "/account/login",
                            l = a.payload?.returnTo;
                        try {
                            let c = new URL(i, window.location.origin);
                            l && c.searchParams.set("return_to", l), (window.location.href = c.toString());
                        } catch {
                            window.location.href = l ? `${i}?return_to=${encodeURIComponent(l)}` : i;
                        }
                    }
                } catch (a) {
                    console.error(a);
                }
        };
    window.addEventListener("message", E, !1);
})();
